import React, { Component } from 'react'
import Dialog from "./../../../../../components/dialog-base"
import './styles.scss'
import connector from 'src/decorators/connector'
import { IStoresMap } from 'src/types'
import drow from './assets/draw.svg'
import drowOrange from './assets/fill-orange.svg'
import info from './assets/information.svg'


interface IFlatsNumbersByFloorsProps {
    onClose: () => void
    item: {
        id: string,
        img: string,
        name: string,
        price: number,
        size: string,
        type: number
    }
}

class FlatsNumbersByFloorsPopUp extends React.Component<IFlatsNumbersByFloorsProps & ReturnType<typeof storesToProps>> {
    public state = {
        countOfFlat: 5,
        numberOfEntr: 1,
        countOfComplect: 1,
        allPrice: 0,
        minEntr: 1,
        maxEntr: 100,
        startFlat: 1,
        flats: [{
            startFlat: 1,
            endFlat: 5,
            countOFflat: 5
        }]
    }

    componentDidMount() {
        const { type } = this.props.item
        if (type === 44) {
            this.setState({ minEntr: 1, maxEntr: 5 })
        }
        if (type === 53) {
            let flats = []
            for (let i = 0; i < 6; i++) {
                flats[i] = {
                    startFlat: i * 5 + 1,
                    endFlat: i * 5 + 5,
                    countOFflat: 5
                }
            }
            this.setState({ minEntr: 6, maxEntr: 14, flats: flats })
        }
        if (type === 82) {
            let flats = []
            for (let i = 0; i < 15; i++) {
                flats[i] = {
                    startFlat: i * 5 + 1,
                    endFlat: i * 5 + 5,
                    countOFflat: 5
                }
            }
            this.setState({ minEntr: 15, maxEntr: 30, flats: flats })
        }
    }

    public onChangedStartFlat = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ startFlat: e.currentTarget.value })
        let newFlats = this.state.flats

        let i = 0
        while (i < newFlats.length && newFlats[i].countOFflat === 0) {
            i++
        }
        for (let j = i; j < newFlats.length; j++) {

            if (j === i && newFlats[j].countOFflat !== 0) {
                newFlats[j].startFlat = Number(e.currentTarget.value)
                newFlats[j].endFlat = newFlats[j].startFlat + newFlats[j].countOFflat - 1
            } else {
                if (newFlats[j].endFlat === 0) {
                    continue
                }
                if (newFlats[j - 1].endFlat === 0) {
                    let lastValue = 0
                    let i = j - 1
                    while (i >= 0) {
                        if (newFlats[i].endFlat > 0) {
                            lastValue = newFlats[i].endFlat
                            i = 0
                        }
                        i--;
                    }
                    newFlats[j].startFlat = lastValue + 1
                    newFlats[j].endFlat = newFlats[j].startFlat + newFlats[j].countOFflat - 1
                } else {
                    newFlats[j].startFlat = newFlats[j - 1].endFlat + 1
                    newFlats[j].endFlat = newFlats[j].startFlat + newFlats[j].countOFflat - 1
                }
            }

        }

    }

    public onChangeNumberOfEntr = (numb: number) => {
        if (numb >= 1 || this.state.numberOfEntr > 1)
            this.setState({ numberOfEntr: this.state.numberOfEntr + numb })
    }

    public onChangeCountOfComplect = (count: number) => {
        if (count >= 1 || this.state.countOfComplect > 1)
            this.setState({ countOfComplect: this.state.countOfComplect + count })
    }



    public onMinusCountOfFloors = () => {
        if (this.state.flats.length > 1 && this.state.flats.length > this.state.minEntr) {
            let newFlats = this.state.flats
            newFlats.pop()
            this.setState({ flats: newFlats })
        }
    }

    public onPlusCountOfFloors = () => {
        if (this.state.flats.length < this.state.maxEntr) {
            let newFlats = this.state.flats
            newFlats.push({
                startFlat: this.state.flats[this.state.flats.length - 1].endFlat + 1,
                endFlat: this.state.flats[this.state.flats.length - 1].endFlat + this.state.countOfFlat,
                countOFflat: this.state.countOfFlat
            })
            this.setState({ flats: newFlats })
        }

    }


    public onMinusCountsFlatsOnFloorAll = () => {
        if (this.state.countOfFlat > 1) {
            let newFlats = this.state.flats
            for (let i = 0; i < newFlats.length; i++) {
                if (newFlats[i].countOFflat === this.state.countOfFlat) {
                    if (i === 0) {
                        newFlats[i].countOFflat = newFlats[i].countOFflat - 1
                        newFlats[i].endFlat = newFlats[i].startFlat + newFlats[i].countOFflat - 1
                    } else {
                        newFlats[i].countOFflat = this.state.countOfFlat - 1
                        newFlats[i].startFlat = newFlats[i - 1].endFlat + 1
                        newFlats[i].endFlat = newFlats[i].startFlat + newFlats[i].countOFflat - 1

                    }
                }
            }
            this.setState({ flats: newFlats, countOfFlat: this.state.countOfFlat - 1 })
        }
    }

    public onPlusCountsFlatsOnFloorAll = () => {
        let newFlats = this.state.flats
        for (let i = 0; i < newFlats.length; i++) {
            if (newFlats[i].countOFflat === this.state.countOfFlat) {
                if (i === 0) {
                    newFlats[i].endFlat = newFlats[i].startFlat + this.state.countOfFlat
                    newFlats[i].countOFflat = newFlats[i].countOFflat + 1
                } else {
                    newFlats[i].startFlat = newFlats[i - 1].endFlat + 1
                    newFlats[i].endFlat = newFlats[i].startFlat + newFlats[i].countOFflat
                    newFlats[i].countOFflat = this.state.countOfFlat + 1
                }
            }

        }
        this.setState({ flats: newFlats, countOfFlat: this.state.countOfFlat + 1 })
    }


    public onMinusCountsFlatsOnFloor = (numberFloor: number) => {
        let newFlats = this.state.flats
        if (newFlats[numberFloor].countOFflat > 0) {
            newFlats[numberFloor].countOFflat--
            newFlats[numberFloor].endFlat--
            for (let i = numberFloor + 1; i < newFlats.length; i++) {
                if (newFlats[i].countOFflat !== 0) {
                    newFlats[i].endFlat--
                    newFlats[i].startFlat--
                }
            }

        }
        if (newFlats[numberFloor].countOFflat === 0) {
            newFlats[numberFloor].startFlat = 0
            newFlats[numberFloor].endFlat = 0
        }
        this.setState({ flats: newFlats })
    }

    public onPlusCountsFlatsOnFloor = (numberFloor: number) => {
        let newFlats = this.state.flats
        if (newFlats[numberFloor].startFlat === 0) {
            let lastValue = this.state.startFlat - 1
            let i = numberFloor - 1
            while (i >= 0) {
                if (newFlats[i].endFlat > 0) {
                    lastValue = newFlats[i].endFlat
                    i = 0
                }
                i--;
            }
            newFlats[numberFloor].startFlat = lastValue + 1
            newFlats[numberFloor].countOFflat++
            newFlats[numberFloor].endFlat = newFlats[numberFloor].startFlat + newFlats[numberFloor].countOFflat - 1

        } else {
            newFlats[numberFloor].countOFflat++
            newFlats[numberFloor].endFlat++
        }
        for (let i = numberFloor + 1; i < newFlats.length; i++) {
            if (newFlats[i].countOFflat !== 0) {
                newFlats[i].endFlat++
                newFlats[i].startFlat++
            }

        }
        this.setState({ flats: newFlats })
    }

    public onMinusStartFlat = (numberFloor: number) => {
        let newFlats = this.state.flats
        if (numberFloor === 0 && newFlats[numberFloor].startFlat > 1) {
            newFlats[numberFloor].startFlat--
            newFlats[numberFloor].countOFflat++
        } else {
            if (numberFloor !== 0 && newFlats[numberFloor].countOFflat > 0 && this.state.flats[numberFloor - 1].endFlat > 0 && this.state.flats[numberFloor].startFlat > this.state.flats[numberFloor - 1].endFlat + 1) {
                newFlats[numberFloor].startFlat--
                newFlats[numberFloor].countOFflat++
            } else {
                let i = numberFloor
                console.log(i)
                while (i >= 0 && newFlats[i].endFlat === 0) {
                    i--
                }
                console.log(i)
                if (i >= 0 && newFlats[i].endFlat > 1 && this.state.flats[numberFloor].startFlat > this.state.flats[numberFloor - 1].endFlat + 1) {
                    newFlats[numberFloor].startFlat--
                    newFlats[numberFloor].countOFflat++
                    // for(let j=i; j < newFlats.length; j++){
                    newFlats[i].endFlat--
                    newFlats[i].countOFflat--
                    //}

                }
            }
        }

        this.setState({ flats: newFlats })
    }

    public onMinusEndFlat = (numberFloor: number) => {
        let newFlats = this.state.flats

        if (this.state.flats[numberFloor].startFlat < this.state.flats[numberFloor].endFlat) {
            newFlats[numberFloor].endFlat--
            newFlats[numberFloor].countOFflat--
            if (numberFloor < this.state.flats.length - 1) {
                newFlats.forEach((el, i) => {
                    if (i > numberFloor && el.endFlat != 0) {
                        newFlats[i].startFlat--
                        newFlats[i].endFlat--
                    }

                });
            }
        }
        this.setState({ flats: newFlats })
    }

    public onPlusEndFlat = (numberFloor: number) => {
        let newFlats = this.state.flats

        if (numberFloor === newFlats.length - 1) {
            newFlats[numberFloor].endFlat++
            newFlats[numberFloor].countOFflat++
        } else {
            if (newFlats[numberFloor + 1].endFlat > newFlats[numberFloor + 1].startFlat) {
                newFlats[numberFloor].endFlat++
                newFlats[numberFloor].countOFflat++
                newFlats.forEach((el, i) => {
                    if (i > numberFloor && el.endFlat != 0) {
                        newFlats[i].startFlat++
                        newFlats[i].endFlat++
                    }

                });
            }
        }

        this.setState({ flats: newFlats })
    }

    public onPlusStartFlat = (numberFloor: number) => {
        let newFlats = this.state.flats

        if (this.state.flats[numberFloor].startFlat < this.state.flats[numberFloor].endFlat) {
            newFlats[numberFloor].startFlat++
            newFlats[numberFloor].countOFflat--
            if (numberFloor > 0 && newFlats[numberFloor - 1].endFlat > 0) {
                newFlats[numberFloor - 1].endFlat++
                newFlats[numberFloor - 1].countOFflat++
            } else {
                let i = numberFloor - 1
                while (i >= 0 && newFlats[i].endFlat === 0) {
                    i--
                }
                if (i >= 0 && newFlats[i].endFlat > 0) {
                    newFlats[i].endFlat++
                    newFlats[i].countOFflat++
                }
            }
        }
        this.setState({ flats: newFlats })
    }

    // public onPlusCountOfFloors = (numb: number) => {
    //     if (numb >= 1 || this.state.numberOfEntr > 1)
    //     this.setState({numberOfEntr: this.state.numberOfEntr + numb})
    // }


    public onAddProduct = () => {
        const { addProduct } = this.props.busket
        const { flats, numberOfEntr } = this.state
        let description = `подъезд №${numberOfEntr} `
        flats.forEach((item, index) => {
            description = description + `этаж ${index + 1} с ${item.startFlat} по ${item.endFlat}, `
        })
        description = description.substring(0, description.length - 2)
        addProduct(this.props.item, this.state.countOfComplect, 0, 0, description)
        this.props.onClose()
    }

    render() {

        const { numberOfEntr } = this.state

        return <Dialog onClose={this.props.onClose}>
            <div className={`floors_number_container popup-${this.props.item.type}`}>
                <img className="dialogClose" onClick={this.props.onClose} src="/local/templates/sign_plus/images/close.svg" alt="" />
                <div className="dialogContaine__inner">
                    <div className="title">
                        {this.props.item.name}
                    </div>
                    <div className="top_block">
                        <img className={this.props.item.type === 39 ? "big_picture" : "small_picture"} src={this.props.item.img} />
                        <div className="container-switchers">
                            <div className="enterances">
                                <div className="title">Подъезд №</div>
                                <div className='swither_container'>
                                    <div className="minus" onClick={() => this.onChangeNumberOfEntr(-1)}>-</div>
                                    <div className="count">{numberOfEntr}</div>
                                    <div className="plus" onClick={() => this.onChangeNumberOfEntr(+1)} >+</div>
                                </div>
                            </div>
                            <div className="floors">
                                <div className="title">Этажей</div>
                                <div className='swither_container'>
                                    <div className="minus" onClick={this.onMinusCountOfFloors} >-</div>
                                    <div className="count">{this.state.flats.length}</div>
                                    <div className="plus" onClick={this.onPlusCountOfFloors}>+</div>
                                </div>
                            </div>
                            <div className="flatsOnFloors">
                                <div className="title">Квартир на этаже</div>
                                <div className='swither_container'>
                                    <div className="minus" onClick={this.onMinusCountsFlatsOnFloorAll}>-</div>
                                    <div className="count">{this.state.countOfFlat}</div>
                                    <div className="plus" onClick={this.onPlusCountsFlatsOnFloorAll} >+</div>
                                </div>
                                <div className='helpers'>
                                    <div className="help">
                                        <div className='help'>Введите максимальное число квартир на этаже в подъезде</div>
                                        <img src={info} />
                                    </div>
                                </div>
                            </div>
                            <div className="startFloor">
                                <div className="title">Нумерация квартир с</div>
                                <div className='swither_container'>
                                    <input className="start_floor" type={"number"} min={1} onChange={this.onChangedStartFlat} value={this.state.startFlat} />
                                </div>
                            </div>
                        </div>
                        <div className="floorsTable">
                            <div className="floors_left">
                                <div className="floors_headers">
                                    Квартир на этаже
                                </div>
                                <div className="floors_body">
                                    {this.state.flats.map((item, index) =>
                                        <div className="numbOfCount">
                                            <div className="minus" onClick={() => this.onMinusCountsFlatsOnFloor(index)}>-</div>
                                            <div className="number">{item.countOFflat}</div>
                                            <div className="plus" onClick={() => this.onPlusCountsFlatsOnFloor(index)}>+</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="floors_right">
                                <div className="floors_headers">
                                    <div className="floors_headers__left">
                                        Этаж
                                    </div>
                                    <div className="floors_headers__right">
                                        Квартиры
                                    </div>
                                </div>
                                {this.state.flats.map((item, index) => <div className="floors_body">
                                    <div className="floors_body__left">
                                        <div className="floor">
                                            {index + 1}
                                        </div>
                                    </div>
                                    <div className="floors_body__right">
                                        <div className="floors">
                                            <div className="startNumb">
                                                <div className="minus" onClick={() => this.onMinusStartFlat(index)}>-</div>
                                                <div className="number">{item.startFlat ? item.startFlat : '-'}</div>
                                                <div className="plus" onClick={() => this.onPlusStartFlat(index)}>+</div>
                                            </div>
                                            <div className="tire">&mdash;</div>
                                            <div className="endNumb">
                                                <div className="minus" onClick={() => this.onMinusEndFlat(index)}>-</div>
                                                <div className="number">{item.endFlat ? item.endFlat : '-'}</div>
                                                <div className="plus" onClick={() => this.onPlusEndFlat(index)} >+</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>)}
                            </div>
                        </div>
                        <div className="countsOfTables">
                            <div className="title">Количество</div>
                            <div className='swither_container'>
                                <div className="minus" onClick={() => this.onChangeCountOfComplect(-1)} >-</div>
                                <div className="count">{this.state.countOfComplect}</div>
                                <div className="plus" onClick={() => this.onChangeCountOfComplect(+1)} >+</div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom_block">
                        <div className="price">{this.props.item.price} руб/шт</div>
                        <div className="count">{this.state.countOfComplect} шт</div>
                        <div className="allPrice">{this.props.item.price * this.state.countOfComplect} руб</div>
                    </div>
                    <div className="inBusker" onClick={this.onAddProduct} >В корзину</div>
                </div>

            </div>
        </Dialog>
    }
}

const storesToProps = ({ store }: IStoresMap, _nextProps: any) => ({
    busket: store.BusketStore
})

export default connector(storesToProps)(FlatsNumbersByFloorsPopUp)
{/* <div class="floorsTable">
  <div class="floors_left">
      <div class="floors_headers">
          Квартир на этаже
        </div>
        <div class="floors_body">
           тут выводишь квартиры на этаже с редактором
                
        </div>
     </div>
     <div class="floors_right">
       <div class="floors_headers">
          <div class="floors_headers__left">
              Этаж
            </div>
            <div class="floors_headers__right">
              Квартиры
            </div>
        </div>
        <div class="floors_body">
          <div class="floors_body__left">
               тут выводишь этажи
            </div>
            <div class="floors_body__right">
            ** тут выводишь квартиры с редактором
            </div>
        </div>
   </div>
</div> */}